import { mediaQuery } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

export const cardsGridStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '20px',

  [mediaQuery.mobileAndTablet]: {
    gridTemplateColumns: '1fr',
  },
};

export const identifierRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '16px 32px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  padding: '16px 24px',

  [mediaQuery.mobile]: {
    padding: '14px 16px',
  },
};

export const identifierItemStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
};
